

/*
angelCake v3.0 (http://angelcake.executiveresults.ca)
Copyright 2018 Executive Results
Licensed under the MIT license
*/

head.ready('appJS',function(){
  $(document).ready(function(){
    //START DROPDOWNS (TOOLTIPSTER)
    angelCake.tooltipInstances = [];
    angelCake.createTooltip = function(elem,trigger){
      if(!elem.hasClass('actooltip-initialized')){

            elem.addClass('actooltip-initialized');
            var ddID = (function(){
              var d = new Date();
              return d.getTime();
            })();
            elem.find('>ac-dropdown-content').attr('id',ddID);
            elem.attr('data-tooltip-content','#'+ddID);
            elem.append('<i class="icon-chevron-down chevron"></i>');
            var attr = elem.attr('dont-init');
            if (typeof attr !== typeof undefined && attr !== false) {
                // ...
            }else{
              return $(elem).tooltipster({
                // functionInit: function(instance, helper){
                // 	if(trigger=='click'){
                // 		var content = $(helper.origin).find('ac-dropdown-content').detach();
                // 	}else{
                // 		var content = $(helper.origin).find('ac-tooltip-content').detach();
                // 	}
                  
                //   instance.content(content);
                // },
                functionInit : function(instance,helper){
                  
                },
                functionBefore : function(instance,helper){
                  $(helper.origin)
                  .addClass('pressed')
                  .find('>.chevron')
                  .removeClass('icon-chevron-down')
                  .addClass('icon-chevron-up');
                },
                functionAfter : function(instance,helper){
                  $(helper.origin)
                  .removeClass('pressed')
                  .find('>.chevron')
                  .removeClass('icon-chevron-up')
                  .addClass('icon-chevron-down');
                },
                theme: 'tooltipster-light',
                trigger : trigger,
                side : 'bottom',
                animationDuration : 0,
                minWidth : 300,
                contentAsHTML: true,
                selfDestruction : false,
                repositionOnScroll: true,
                interactive : true,
                plugins: ['sideTip', 'scrollableTip']
              });
            }
      }
    };
    $('ac-dropdown').each(function(){
      
        angelCake.tooltipInstances.push(angelCake.createTooltip($(this),'click'));
      
    });
    $('ac-tooltip').each(function(){
        angelCake.tooltipInstances.push(angelCake.createTooltip($(this),'hover'));
      
    });
    //END DROPDOWNS (TOOLTIPSTER)
  });
});